<template>
	<div class="app-logo-container">
		<img alt="logo" class="app-logo" src="~@img/misc/lineal_logo.png">
	</div>
</template>

<script>
	export default {
		name: 'admin-app-logo'
	}
</script>

<style lang="less" scoped>
	.app-logo-container {
		width: fit-content;
		margin: 0px auto 0px auto;
	}

	.app-logo {
		width: 196px;
		height: auto;
	}
</style>
